import type { LegalDocSlug } from './legalDocs';

// Vite: load markdown content as raw strings.
const mdModules = import.meta.glob('./content/*.md', {
  eager: true,
  query: '?raw',
  import: 'default',
}) as Record<string, string>;

function fileForSlug(slug: LegalDocSlug): string {
  switch (slug) {
    case 'terms':
      return '01_Terms_of_Service.md';
    case 'privacy':
      return '02_Privacy_Policy.md';
    case 'acceptable-use':
      return '03_Acceptable_Use_Policy.md';
    case 'refund-cancellation':
      return '04_Refund_Cancellation_Policy.md';
    case 'cookie':
      return '05_Cookie_Policy.md';
    case 'coppa':
      return '06_COPPA_Compliance_Policy.md';
    case 'sla':
      return '07_Service_Level_Agreement.md';
    case 'safety-ai-disclaimer':
      return '08_Safety_AI_Disclaimer.md';
    default: {
      const _exhaustive: never = slug;
      return _exhaustive;
    }
  }
}

export function getLegalMarkdown(slug: LegalDocSlug): string | null {
  const filename = fileForSlug(slug);
  const key = `./content/${filename}`;
  return mdModules[key] ?? null;
}

